import { StyledPremiumBanner } from './styled';

const FeaturesBanner = () => (
  <StyledPremiumBanner>
    <h1 className="cta-heading">Create. Share. Interact.</h1>
    <div className="lead">Collect responses as easy as 1, 2 and 3!</div>
  </StyledPremiumBanner>
);

export default FeaturesBanner;
